import { signalStore, withState, withMethods, patchState, withComputed } from '@ngrx/signals';
import { computed, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { withLoadingState } from '../loading-state/with-loading-state';
import { PersonalizationState } from '../types/personalization.type';
import { PersonalizationService } from '../../services/api/personalization/personalization.service';

export const PersonalizationStore = signalStore(
	{ providedIn: 'root' },
	withState<PersonalizationState>({
		colors: [],
	}),
	withLoadingState({ colors: 'init' }),
	withMethods((state) => {
		const personalizationService = inject(PersonalizationService);
		return {
			fetchColors: async () => {
				state.loading('colors');
				const colors = await firstValueFrom(personalizationService.fetchColors());
				patchState(state, { colors });
				state.loaded('colors');
			},
		};
	}),
	withComputed(({ colors }) => ({
		preselectedColor: computed(() => colors().find((color) => color.isPreselected)),
		showColorDot: computed(() => colors().length > 1),
	})),
);
